import { render } from "./Greeting.vue?vue&type=template&id=33ee00a8&scoped=true&ts=true"
import script from "./Greeting.vue?vue&type=script&lang=ts"
export * from "./Greeting.vue?vue&type=script&lang=ts"

import "./Greeting.vue?vue&type=style&index=0&id=33ee00a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ee00a8"]])

export default __exports__